import React from 'react';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import Button from '../../Common/Button';
import resx from '../../../utilities/resx';
import Mixpanel from '../../../API/Mixpanel';
import { RESX_GLOBAL, MIXPANEL_INTENT } from '../../../Constants';


const EmptyFeed = props => {
    let body, link, cta;

    switch (props.page) {
        case 'myposts': {
            body = resx(RESX_GLOBAL, 'EMPTY_FEED_MY_POST_BODY');
            cta = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_CTA');
            break;
        }
        case 'connections': {
            body = resx(RESX_GLOBAL, 'EMPTY_FEED_CONNECTIONS_BODY');
            link = '/agents';
            cta = resx(RESX_GLOBAL, 'EMPTY_FEED_CONNECTIONS_CTA');
            break;
        }
        case 'local': {
            body = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_BODY');
            cta = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_CTA');
            break;
        }
        case 'hashtag': {
            body = resx(RESX_GLOBAL, 'EMPTY_FEED_HASHTAG_BODY');
            cta = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_CTA');
            break;
        }
        case 'group': {
            switch (props.isGroupMember) {
                case true: {
                    body = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_BODY');
                    cta = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_CTA');
                    break;
                }
                default: {
                    body = resx(RESX_GLOBAL, 'EMPTY_FEED_GROUP_NON_MEMBER_BODY');
                    break;
                }
            }
            break;
        }
        case 'myprofile': {
            body = resx(RESX_GLOBAL, 'EMPTY_FEED_MY_PROFILE_BODY');
            link = '/feed/global?createpost=true';
            cta = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_CTA');
            break;
        }
        case 'userprofile': {
            body = _path(['User2', 'UserId'], RESAAS) ? resx(RESX_GLOBAL, 'EMPTY_FEED_USER_PROFILE_BODY') : resx(RESX_GLOBAL, 'EMPTY_FEED_ANONYMOUS_USER_PROFILE_BODY');
            cta = null;
            break;
        }
        case 'nocontext': {
            body = `It seems like the feed you're looking for could not be found.`;
            link ='/feed/global'
            cta = 'Explore The Global Feed';
            break;
        }
        default: {
            body = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_BODY');
            link = null;
            cta = resx(RESX_GLOBAL, 'EMPTY_FEED_GENERIC_CTA');
            break;
        }
    }

    const handleCtaBtn = link => {
        Mixpanel.add(MIXPANEL_INTENT, { type: 'EmptyFeed, create post' });
        if (link) {
            window.location.assign(link);
        } else {
            document.querySelector('.js-feedssearch-postreblasts').classList.remove('re-postreblasts-condensed');
            document.getElementById('ctl00_Body_txtMessage').focus();
        }
    };

    return (
        <div className="re-container re-container-outer text-center no-activity">
            <div data-testid="emptyfeedmessage">{body}</div>
            {cta ? (
                <Button
                    className="re-btn re-btn-large"
                    dataTestid="emptyfeed"
                    type="button"
                    text={cta}
                    onClick={() => handleCtaBtn(link)}
                />
            ) : null}
        </div>
    );
};

EmptyFeed.propTypes = {
    page: PropTypes.string,
    isGroupMember: PropTypes.bool
};

export default EmptyFeed;
